import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

const TextFieldStyled = styled(TextField)(({ theme }) => ({
  '& label.MuiFormLabel-root': {
    color: theme?.palette?.form?.labelColor || '#707070',
    fontSize: theme?.typography?.pxToRem?.(12) || '0.75rem',
    paddingLeft: 16,
    backgroundColor: 'inherit',
  },
  '& label.MuiFormLabel-filled': {
    color: theme?.palette?.form?.labelFilledColor || '#777777',
    fontSize: theme?.typography?.pxToRem?.(13) || '0.8125rem',
    background: 'inherit',
    paddingLeft: 0,
  },
  '& label.Mui-focused': {
    color: theme?.palette?.primary?.main || '#387FF7',
    fontSize: theme?.typography?.pxToRem?.(13) || '0.8125rem',
    background: 'inherit',
    paddingLeft: 0,
  },
  '& label.Mui-error': {
    color: theme?.palette?.error?.main || '#FA5252',
  },
  '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
    borderBottomColor: theme?.palette?.form?.border || '#777777',
  },
  '& .MuiInput-underline:before': {
    borderBottomColor: theme?.palette?.form?.border || '#777777',
  },
  '& .MuiInput-root .MuiInputBase-input': {
    fontSize: theme?.typography?.pxToRem?.(14) || '0.875rem',
    padding: '6px 30px 6px 16px',
  },
  '& .MuiFormHelperText-root': {
    fontSize: theme?.typography?.pxToRem?.(12) || '0.75rem',
    marginLeft: 16,
  },
}));

export default TextFieldStyled;
